module.exports = __webpack_public_path__ + "img/tonelada.78018f1b.jpeg";